// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1Q8vZ","title":"FrontImage_title__3ITZ9"};